import React from "react"
import PropTypes from "prop-types"
import PrimaryButton from "../../../components/molecules/buttons/PrimaryButton.molecule"
import { useSession } from "../../../hooks/auth/useSession.hook"
import { useNavigate } from "react-router-dom"
import { AppRoutes } from "../../../consts/appRoutes.consts"
import useReportFiltersContext from "../../../hooks/contextConsumers/useReportFiltersContext.hook"

const NavigateToBudgetButton = ({
  clientId = null,
  isClientBillable = false,
  loading = false,
}) => {
  const { user } = useSession()
  const { clientReportClients } = useReportFiltersContext()
  const navigate = useNavigate()
  if ((!user?.isAdmin() || !user?.isTeamLeader()) && !isClientBillable) {
    return null
  }
  const client = clientReportClients.find((c) => c.clientId === clientId)
  if (!client) {
    return null
  }
  return (
    <PrimaryButton
      btnType="outlined"
      className="white-space-nowrap flex-shrink-0"
      label={"Ir al presupuesto"}
      icon={`pi pi-arrow-right`}
      onClick={() =>
        navigate(AppRoutes.clientes.presupuestoCliente, {
          state: {
            id: clientId,
            code: client.code,
            name: client.name,
          },
        })
      }
      disabled={loading}
    />
  )
}

export default NavigateToBudgetButton

NavigateToBudgetButton.propTypes = {
  clientId: PropTypes.number,
  isClientBillable: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  loading: PropTypes.bool,
}
